const getters = {
  token: state => state.user.token,
  userId: state => state.user.userId,
  nickname: state => state.user.nickname,
  avatar: state => state.user.avatar,
  permissions: state => state.user.permissions,
  routes: state => state.permission.routes
}
export default getters
